import React from "react";
import { Paper, Alert } from "@mui/material";
import { useParams } from "react-router-dom";
import { getJobDocument } from "../../services/deployment";
import { useQuery } from "react-query";
import CircularProgress from "@mui/material/CircularProgress";

const DeploymentJobDocumentTab = () => {
  const params = useParams();
  const { deploymentId = "" } = params;

  // Queries
  const {
    data: { data: { document: jobDocument = null } = {} } = {},
    isLoading,
  } = useQuery(["jobDocument", deploymentId], getJobDocument);

  const PrettyPrintJson = (document) => {
    if (document && document.data) {
      return (
        <div className="job-document-container">
          <pre style={{ fontSize: 12 }}>
            {JSON.stringify(JSON.parse(document.data), null, 2)}
          </pre>
        </div>
      );
    }
    return (
      <Alert variant="outlined" severity="warning">
        Document not found!
      </Alert>
    );
  };

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Paper elevation={0} sx={{ overflow: "auto", maxHeight: 700 }}>
          <PrettyPrintJson data={jobDocument}></PrettyPrintJson>
        </Paper>
      )}
    </>
  );
};

DeploymentJobDocumentTab.defaultProps = {};

DeploymentJobDocumentTab.propTypes = {};

export default DeploymentJobDocumentTab;
